import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1680 255",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1564.53 97.528L1686 74.2377V228H0V0C0 0 149.527 113.523 344.728 135.957C388.43 140.98 460.207 144.4 460.207 144.4H547.458C547.458 144.4 698.146 163.145 798.947 168.563C909.196 174.489 1084.65 171.183 1084.65 171.183L1248.03 157.792H1280.54L1319.89 148.184H1342.13L1528.61 97.528H1564.53Z",
		fill: "#031839",
		fillOpacity: .2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M121.467 124.528L0 101.238V255H1686V27C1686 27 1536.47 140.523 1341.27 162.957C1297.57 167.98 1225.79 171.4 1225.79 171.4H1138.54C1138.54 171.4 987.854 190.145 887.053 195.563C776.804 201.489 601.349 198.183 601.349 198.183L437.967 184.792H405.461L366.113 175.184H343.872L157.394 124.528H121.467Z",
		fill: "#031839"
	})]
});
const SvgFooter = styled(base)({});
export default SvgFooter;
